import React from 'react';
import { IconStyles } from '../SelectIcon';

export const Desenvolvimento = (props) => {
  const fillColors = {
    lightGrey: '#ebebeb',
    blue: '#08605f',
    white: '#fff',
  };
  return (
    <svg
      style={IconStyles}
      aria-label={props.label}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 221.5 184.3"
    >
      <path
        fill={fillColors.lightGrey}
        d="M182.3 153.4c0 .5-.3.8-.6.8l-3.1-.2c-.4 0-.6-.4-.6-.8l.1-2.5c0-.5.3-.8.7-.8l3.1.1c.3 0 .6.4.6.9zM181 178c0-.4-.1-.7-.5-.7l-3.1-.2c-.3 0-.6.3-.6.8l-.2 2.5c0 .4.3.8.6.8l3.1.2c.4 0 .6-.3.7-.8zM175.9 153.7a.7.7 0 0 1-.2 1l-2.8 1.4c-.3.1-.7 0-1-.5l-1-2.2a.7.7 0 0 1 .1-1l2.8-1.4a.7.7 0 0 1 .9.4zM187.1 175.7c-.2-.4-.6-.6-.9-.5l-2.8 1.4a.7.7 0 0 0-.2 1l1.2 2.3a.7.7 0 0 0 .9.5l2.8-1.5a.7.7 0 0 0 .2-1zM170.4 157.1a.7.7 0 0 1 .3 1l-1.7 2.6a.7.7 0 0 1-1 0l-2.1-1.3a.7.7 0 0 1-.4-1l1.7-2.6a.7.7 0 0 1 1 0zM191.1 170.5a.7.7 0 0 0-1 0l-1.7 2.7a.7.7 0 0 0 .3 1l2.2 1.3a.7.7 0 0 0 1 0l1.7-2.7a.7.7 0 0 0-.4-.9zM167.3 162.8c.5 0 .8.3.8.7l-.2 3.1c0 .4-.4.6-.8.6l-2.5-.1c-.5 0-.8-.4-.8-.7l.2-3.1c0-.4.3-.6.8-.6zM192 164.1c-.5 0-.8.2-.8.6l-.2 3.1c0 .3.3.6.8.6l2.5.2a.7.7 0 0 0 .8-.6l.2-3.1c0-.4-.3-.7-.8-.7zM167.6 169.3a.7.7 0 0 1 1 .2l1.4 2.8c.1.3 0 .7-.5.9l-2.2 1.2a.7.7 0 0 1-1-.2l-1.4-2.8a.7.7 0 0 1 .4-1zM189.6 158c-.4.3-.6.7-.5 1l1.4 2.8a.8.8 0 0 0 1 .2l2.3-1.2a.7.7 0 0 0 .4-1l-1.4-2.7a.7.7 0 0 0-1-.2zM171 174.8a.7.7 0 0 1 1-.3l2.6 1.7a.7.7 0 0 1 0 1l-1.3 2.1a.7.7 0 0 1-1 .4l-2.6-1.7a.7.7 0 0 1 0-1zM184.4 154.1a.7.7 0 0 0 .1 1l2.6 1.7a.7.7 0 0 0 1-.3l1.4-2.2a.7.7 0 0 0-.1-1l-2.6-1.7a.7.7 0 0 0-1 .4z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M180.2 152.4a13.3 13.3 0 1 0 12.6 14 13.3 13.3 0 0 0-12.6-14zm-1 22a8.7 8.7 0 1 1 9-8.3 8.7 8.7 0 0 1-9 8.3zM27.5 29.7a1.4 1.4 0 0 1-1.4 1.4h-7.2a1.4 1.4 0 0 1-1.3-1.4v-4.2a1.4 1.4 0 0 1 1.3-1.4h7.2a1.4 1.4 0 0 1 1.4 1.4z"
      />
      <rect
        fill={fillColors.lightGrey}
        x="17.6"
        y="62.1"
        width="9.9"
        height="7"
        rx="1.4"
        ry="1.4"
      />
      <path
        fill={fillColors.lightGrey}
        d="M14 31.2a1.4 1.4 0 0 1 0 1.9l-5 5a1.4 1.4 0 0 1-2 0l-3-3a1.4 1.4 0 0 1 0-1.9l5.2-5a1.4 1.4 0 0 1 1.9 0zM38 55a1.4 1.4 0 0 0-2 0l-5 5.1a1.4 1.4 0 0 0 0 2l3 3a1.4 1.4 0 0 0 2 0l5-5.1a1.4 1.4 0 0 0 0-2zM5.6 41.7A1.4 1.4 0 0 1 7 43v7.2a1.4 1.4 0 0 1-1.4 1.4H1.4A1.4 1.4 0 0 1 0 50.2V43a1.4 1.4 0 0 1 1.4-1.4zM39.4 41.7A1.4 1.4 0 0 0 38 43v7.2a1.4 1.4 0 0 0 1.4 1.4h4.2a1.4 1.4 0 0 0 1.4-1.4V43a1.4 1.4 0 0 0-1.4-1.4zM7 55a1.4 1.4 0 0 1 2 0l5 5.1a1.4 1.4 0 0 1 0 2l-3 3a1.4 1.4 0 0 1-1.8 0L4 60a1.3 1.3 0 0 1 0-2zM31 31.2a1.4 1.4 0 0 0 0 1.9l5 5a1.4 1.4 0 0 0 2 0l3-3a1.4 1.4 0 0 0 0-1.9l-5.2-5a1.4 1.4 0 0 0-1.9 0z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M22.5 30.8a15.8 15.8 0 1 0 15.9 15.8 15.8 15.8 0 0 0-15.9-15.8zm0 28.3A12.5 12.5 0 1 1 35 46.6a12.5 12.5 0 0 1-12.5 12.5zM100.1 119.9a30.6 30.6 0 1 0 38.7 19.5A30.6 30.6 0 0 0 100 120zm15.9 48.3a20.2 20.2 0 1 1 12.9-25.5 20.2 20.2 0 0 1-12.9 25.5z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M107.5 120.5a1.9 1.9 0 0 1-1.2 2.4L97 126a1.9 1.9 0 0 1-2.4-1.2l-1.8-5.6a1.9 1.9 0 0 1 1.2-2.4l9.4-3a1.9 1.9 0 0 1 2.4 1.1zM124.8 173.2a1.8 1.8 0 0 0-2.4-1.2l-9.4 3a1.9 1.9 0 0 0-1.2 2.4l1.8 5.6a1.9 1.9 0 0 0 2.4 1.2l9.4-3a1.9 1.9 0 0 0 1.2-2.4zM88 130.4a1.9 1.9 0 0 1 .8 2.5l-4.4 8.8a1.9 1.9 0 0 1-2.6.9l-5.2-2.7a1.9 1.9 0 0 1-.9-2.5l4.5-8.8a1.9 1.9 0 0 1 2.5-.9zM137.5 155.4a1.9 1.9 0 0 0-2.6.8l-4.4 8.9a1.9 1.9 0 0 0 .8 2.5l5.3 2.6a1.9 1.9 0 0 0 2.5-.8l4.5-8.9a1.9 1.9 0 0 0-.9-2.5zM81.2 151.1a1.9 1.9 0 0 1 2.4 1.2l3 9.4a1.9 1.9 0 0 1-1.1 2.4l-5.6 1.9a1.9 1.9 0 0 1-2.4-1.2l-3-9.4a1.9 1.9 0 0 1 1.1-2.4zM133.8 133.8a1.9 1.9 0 0 0-1.2 2.4l3.1 9.4a1.9 1.9 0 0 0 2.4 1.2l5.6-1.8a1.9 1.9 0 0 0 1.2-2.4l-3-9.4a1.9 1.9 0 0 0-2.4-1.2zM91 170.6a1.9 1.9 0 0 1 2.6-.8l8.8 4.5a1.9 1.9 0 0 1 .9 2.5l-2.7 5.2a1.9 1.9 0 0 1-2.5.8l-8.9-4.4a1.9 1.9 0 0 1-.8-2.6zM116 121.2a1.9 1.9 0 0 0 .9 2.5l8.8 4.5a1.9 1.9 0 0 0 2.5-.8l2.7-5.3a1.9 1.9 0 0 0-.8-2.5l-8.9-4.5a1.9 1.9 0 0 0-2.5.8z"
      />
      <path
        fill={fillColors.blue}
        d="M38 119a7.6 7.6 0 0 0 7.7 7.7H205a7.6 7.6 0 0 0 7.6-7.7V7.7A7.6 7.6 0 0 0 205 0H45.7A7.6 7.6 0 0 0 38 7.7z"
      />
      <path
        fill={fillColors.white}
        d="M205 110c.8 0 1.2-.5 1.2-.7V7.7a1.1 1.1 0 0 0-1.2-.8H45.7a1.2 1.2 0 0 0-1.2.8v101.5c0 .2.4.7 1.2.7z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M29.1 122.8c0 3.2 4 5.8 8.8 5.8h174.9c4.8 0 8.7-2.6 8.7-5.8 0-3.3-3.9-5.9-8.7-5.9h-175c-4.8 0-8.7 2.6-8.7 5.9zM205 7H45.7a1.2 1.2 0 0 0-1.2.7v11.6h161.7V7.6A1.1 1.1 0 0 0 205 7z"
      />
      <path
        fill={fillColors.blue}
        d="M61 13.1a2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1 5 0zM67.4 13.1a2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1 5 0zM44.5 19.3h161.7v18.3H44.5z"
      />
      <path
        fill={fillColors.white}
        d="M49.5 25.2h28.3v7.6H49.5zM92.3 25.2h55v7.6h-55zM157.7 25.2H196v7.6h-38.3z"
      />
      <path
        fill={fillColors.blue}
        d="M49.5 47.5h39.8v5.7H49.5zM49.5 57h39.8v5.7H49.5zM49.5 66.5h39.8v5.7H49.5zM49.5 76h39.8v5.7H49.5zM49.5 85.5h39.8v5.7H49.5zM49.5 95h39.8v5.7H49.5z"
      />
      <path fill={fillColors.lightGrey} d="M100.5 47.5h54.6V99h-54.6z" />
      <path
        fill={fillColors.lightGrey}
        d="M100.5 78.3l4.3-9.1 5.5 8.2L121.5 57l6.3 16.7 4.2-4.6 4.8 4.6 6-9.6 7 15.4 5.3-13v32.5h-54.6V78.3z"
      />
      <path
        fill={fillColors.blue}
        d="M100.5 84.5l11-20.3 6.3 20.3 4.4-2.9 5.5 7.3 9.8-22.3 5 18 7.4-10.8 5.2 11.2v14h-54.6V84.5z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M161.1 81.7h8.6v17.4h-8.6zM174.9 57.1h8.6v42h-8.6z"
      />
      <path fill={fillColors.blue} d="M188.7 72.2h8.6v26.9h-8.6z" />
    </svg>
  );
};

export default Desenvolvimento;



// WEBPACK FOOTER //
// ./src/components/UI/Img/SelectSVG/Desenvolvimento.jsx